import { Star } from "lucide-react";
import { ResponsiveContainer, AreaChart, Area, YAxis } from "recharts";
import { cn } from "@/lib/utils";

const SPARK_MARGIN = { top: 2, right: 0, left: 0, bottom: 0 };
const GOLD = "#BF9B30";

export const StarRating = ({ value, size = 15, className }) => {
  const pct = Math.max(0, Math.min((value || 0) / 5, 1)) * 100;
  return (
    <span className={cn("relative inline-flex shrink-0", className)} aria-label={`${value ?? 0} out of 5 stars`}>
      <span className="flex flex-nowrap text-[hsl(var(--border))]">
        {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={size} className="shrink-0" fill="currentColor" strokeWidth={0} />)}
      </span>
      <span className="absolute inset-y-0 left-0 flex flex-nowrap overflow-hidden text-[hsl(var(--cx-gold))]" style={{ width: `${pct}%` }}>
        {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={size} className="shrink-0" fill="currentColor" strokeWidth={0} />)}
      </span>
    </span>
  );
};

/* ▲/▼ vs the 1st of the month — always two decimals per spec */
export const RatingDelta = ({ delta, className }) => {
  if (delta === null || delta === undefined)
    return <span className={cn("text-xs text-muted-foreground tabular", className)}>—</span>;
  if (delta === 0)
    return <span className={cn("text-xs text-muted-foreground tabular", className)}>= 0.00</span>;
  const up = delta > 0;
  return (
    <span className={cn("text-xs font-semibold tabular whitespace-nowrap",
      up ? "text-[hsl(var(--status-green))]" : "text-[hsl(var(--cx-crimson))]", className)}>
      {up ? "▲" : "▼"} {Math.abs(delta).toFixed(2)}
    </span>
  );
};

export const RatingSparkline = ({ spark, height = 40 }) => {
  if (!spark?.length) return null;
  const values = spark.map((p) => p.r);
  const min = Math.min(...values) - 0.1;
  const max = Math.max(...values) + 0.1;
  return (
    <div style={{ height }} className="-mx-1">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={spark} margin={SPARK_MARGIN}>
          <YAxis hide domain={[min, max]} />
          <Area type="monotone" dataKey="r" stroke={GOLD} fill={GOLD}
            fillOpacity={0.12} strokeWidth={1.5} isAnimationActive={false} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
